import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { AvailabilitySlot } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Per-court per-hour availability for a facility on a given venue-local date.
 * Wraps GET /facilities/{id}/availability?date=YYYY-MM-DD (player-callable).
 *
 * `date` MUST be the venue-local calendar date (YYYY-MM-DD); the backend
 * interprets it in the facility timezone. An empty slot array is an honest
 * "nothing available" — the grid renders an empty state, never invents slots.
 */
export function useAvailability(
  facilityId: string | undefined,
  date: string | undefined,
) {
  return useQuery<AvailabilitySlot[]>({
    queryKey: queryKeys.booking.availability(facilityId ?? "", date ?? ""),
    queryFn: () =>
      facilityApi.getAvailability(facilityId as string, date as string),
    enabled: Boolean(facilityId) && Boolean(date),
  });
}
